<template>
	<div>
		<compFormEdit ref="formbase" class="margin-layout" :formdata="getBase" v-model="formData" col="1"></compFormEdit>
		<vButtonGroup class="text-right margin-top-10">
			<vButton theme="primary" @click="submit">{{$t('global.common.save', { defaultValue: '保存' })}}</vButton>
			<vButton @click="cancel">{{$t('global.common.return', { defaultValue: '返回' })}}</vButton>
		</vButtonGroup>
		<vModal
			v-model="modalProps.show"
			:title="modalProps.title"
			:width="modalProps.width||1000"
			:showFooter="false"
			@on-close="modalProps.show=false"
		>
			<component
				:is="modalProps.component"
				@on-close="modalProps.show=false"
				v-on="modalProps.on"
				v-bind="modalProps.props"
			></component>
		</vModal>
		<vLoading size="large" transfer :loading="loading"></vLoading>
	</div>
</template>

<script>
import { HttpInventoryCodeMapSaveOne, HttpGetSku } from "@/service/inventory";
// import compSkucode from "./skucode";
import compSkucode from "@components/templates/erpsku.vue";
import { mapGetters } from 'vuex';
export default {
	components: {
		compFormEdit: () => import("@components/templates/formedit"),
		compSkucode,
	},
	data() {
		return {
			loading: false,
			formData: {},
			modalProps: {
				show: false,
			}
		}
	},
	computed: {
		...mapGetters('dictionary', ['getWarehouseAllList']),
		getBase() {
			return [
				{
					label: "SKU",
					tag: "vInput",
					key: "itemsku",
					props: {
						suffix: "search",
						readonly: true
					},
					on: {
						'on-icon-click': this.handleModal
					},
				},
				{
					label: this.$t('fbb.localemanage.skualiased', { defaultValue: "已有产品识别码" }),
					key: "depotskualiased",
					tag: "vTextarea",
					props: {
						readonly: true,
						disable: false,
					},
					required: false,
				}, {
					label: this.$t('fbb.sku.code', { defaultValue: "SKU识别码" }),
					key: "depotskualias",
					formItem: {
						tip: this.$t('fbb.localemanage.attention_1', { defaultValue: "(*设置之后不可修改;多个识别码可用，分隔)" })
					}
				}, {
					label: this.$t('global.common.warehouse', { defaultValue: "仓库" }),
					key: "orgWarehouseIds",
					tag: "vSelect",
					options: this.getWarehouseAllList,
					formItem: {
						tip: this.$t('fbb.localemanage.attention_2', { defaultValue: "(*推送的仓库)" })
					},
					props: {
						multiple: true,
						filterable: true,
					},
					required: false,
				},
			];
		},
	},
	methods: {
		cancel() {
			this.$emit('on-close')
		},
		handleModal() {
			this.modalProps = {
				show: true,
				title: this.$t('fbb.localemanage.find_sku', { defaultValue: 'sku查找' }),
				component: "compSkucode",
				// props: {
				// 	startUp: 1
				// },
				on: {
					'on-data': async (row) => {
                        let depotskualias = await this.getSkuCode(row.erpSku);
						this.formData = { itemsku: row.erpSku, productId: row.id, depotskualiased: depotskualias, groupCode: row.lineId };
						this.modalProps = {};
					}
				}
			}
		},
        async getSkuCode (erpSku) {
            let data = '';
            await HttpGetSku({
                sku: erpSku
            }).then(res => {
                data = res.data ? res.data : '';
            }, err => {
                this.$VMessage.error(err);
            });
            return data;
        },
		async submit() {
			const valid = await this.$refs.formbase.validate();
			if (!valid) return;
			this.loading = true;
			HttpInventoryCodeMapSaveOne(this.formData).then(res => {
				this.cancel();
				this.$emit('on-update');
				this.loading = false;
			}).catch(err => {
				this.loading = false;
				this.$VMessage.error(this.$t(err.langCode, { defaultValue: err.message }))
			})
		},
	},
}
</script>
